module.exports = __webpack_public_path__ + "img/suenio_success.59a69632.svg";